import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useCustomerAuth } from "@/context/CustomerAuthContext";

export default function CustomerProtectedRoute({ children }) {
  const { customer, bootstrapped } = useCustomerAuth();
  const location = useLocation();
  if (!bootstrapped) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--st-cream)]">
        <div className="font-display uppercase tracking-widest text-sm text-[var(--st-fg)]/60">
          Loading…
        </div>
      </div>
    );
  }
  if (!customer) {
    return (
      <Navigate
        to="/account/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }
  return children;
}
